import React from "react";

export default function SessionExpiredModal({ onRestart }) {
   return (
      <div className="modal-overlay">
         <div className="modal-container session-expired-modal">
            <div className="modal-content">
               <h2 className="modal-title">Sesiunea a expirat</h2>
               <p className="modal-message">
                  Te rugăm să reiei procesul de contractare pentru a finaliza cu succes.
               </p>
               <button className="btn-primary modal-button" onClick={onRestart}>
                  Reîncepe
               </button>
            </div>
         </div>
      </div>
   );
}